'use strict';

import 'Components/form/VZInputField';
import VZSpinner from 'Components/VZSpinner';
import { validateForm } from 'app_vodafone_ziggo/util/validation';

export class VZProductMailModal {
    constructor() {
        this.emailElement = document.getElementById('dwfrm_shareConfiguration_email');
        this.sendEmailForm = this.emailElement.closest('form');

        // Grabbing the form using this attribute so its dynamic
        this.productForm = document.querySelector('[data-share-configuration]');

        this.onSubmit = this.onSubmit.bind(this);
        this.setCSRFToken = this.setCSRFToken.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.sendEmailForm.addEventListener('submit', this.onSubmit);
    }

    static addBodyToPostRequest(form, options, method) {
        if (method.toLowerCase() === 'post') {
            options.body = new FormData(form);
        }
    }

    onSubmit(evt) {
        evt.preventDefault();

        const spinner = document.querySelector('vz-spinner') || new VZSpinner();
        spinner.start();

        if (validateForm(this.sendEmailForm)) {
            this.setCSRFToken();

            // Submit Group
            const options = {
                method: this.productForm.method
            };

            // Add body conditionally depending on type of request
            this.constructor.addBodyToPostRequest(this.productForm, options, options.method);

            fetch(this.productForm.action, options).then(() => {
                this.emailAddress = this.emailElement.value;
                this.sendEmail();
                spinner.stop();
            });
        } else {
            spinner.stop();
        }
    }

    sendEmail() {
        const options = {
            method: this.sendEmailForm.method
        };

        // Add body conditionally depending on type of request
        this.constructor.addBodyToPostRequest(this.sendEmailForm, options, options.method);

        // Grab elements to replace text content
        const modalTitle = this.sendEmailForm.querySelector('.js-mail-modal-title');
        const modalBody = this.sendEmailForm.querySelector('.js-mail-modal-body');
        const modalFooter = this.sendEmailForm.querySelector('.js-mail-modal-footer');
        const modalCloseButton = this.sendEmailForm.querySelector('.js-mail-modal-close');
        const modalConfirmTitleText = modalTitle.dataset.confirmationTitle;
        const modalConfirmHeadingText = modalBody.dataset.confirmationHeading;
        let modalConfirmBodyText = modalBody.dataset.confirmationBody;
        const { confirmButtonCloseText } = modalFooter.dataset;

        if (this.emailAddress && modalConfirmBodyText.indexOf('{0}') >= 0) {
            modalConfirmBodyText = modalConfirmBodyText.replace('{0}', this.emailAddress);
        }

        const modalConfirmBody = `
            <h3 class="text-primary">${modalConfirmHeadingText}</h3>
            <p>${modalConfirmBodyText}</p>
        `;

        const modalConfirmButtons = `
            <div class="col-auto">
                <a href="javascript:location.reload()" class="btn btn-outline-secondary mb-2 mb-md-0 w-100" rel="noindex" aria-label="Close">${confirmButtonCloseText}</a>
            </div>
        `;

        fetch(this.sendEmailForm.action, options)
            .then((resp) => resp.json())
            .then((resp) => {
                this.setCSRFToken(resp.csrf_token);
                // Replace text
                modalCloseButton.remove();
                modalFooter.classList.remove('justify-content-start');
                modalFooter.classList.add('justify-content-between');
                modalTitle.textContent = modalConfirmTitleText;
                modalBody.innerHTML = modalConfirmBody;
                modalFooter.innerHTML = modalConfirmButtons;
            });
    }

    setCSRFToken(csrfToken) {
        if (window.csrf) {
            this.sendEmailForm.insertAdjacentHTML(
                'beforeend',
                `
                <input type="hidden" name="${csrfToken || window.csrf.tokenName}" value="${csrfToken || window.csrf.token}" />
            `
            );
        }
    }
}
